import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../Config';

const DemandeListVehicule = () => {
    const [demandes, setDemandes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [user, setUser] = useState(null);
    const [filter, setFilter] = useState('all');
    const [searchTerm, setSearchTerm] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'created_at', direction: 'desc' });

    const token = localStorage.getItem('token');

    useEffect(() => {
        const userData = localStorage.getItem('user');
        if (userData) {
            setUser(JSON.parse(userData));
        }
        fetchDemandes();
    }, []);

    const fetchDemandes = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${API_URL}/demandes-reparations`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setDemandes(response.data);
            setError(null);
        } catch (err) {
            setError('Erreur lors du chargement des demandes');
            console.error('Erreur API:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Êtes-vous sûr de vouloir supprimer cette demande?')) return;

        if (!user || !['validateur', 'chef_equipe'].includes(user.role)) {
            alert('Vous n\'avez pas les droits pour supprimer une demande');
            return;
        }

        try {
            await axios.delete(`${API_URL}/demandes-reparations/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            fetchDemandes();
        } catch (err) {
            alert('Erreur lors de la suppression');
            console.error(err);
        }
    };

    const translateStatus = (statut) => {
        const statusMap = {
            'en_attente': 'En attente',
            'valide': 'Validée',
            'refuse': 'Refusée',
            'en_reparation': 'En réparation',
            'termine': 'Terminée'
        };
        return statusMap[statut] || statut;
    };

    const getStatusBadge = (statut) => {
        switch(statut) {
            case 'valide':
                return 'bg-green-100 text-green-800 border-green-200';
            case 'en_attente':
                return 'bg-yellow-100 text-yellow-800 border-yellow-200';
            case 'refuse':
                return 'bg-red-100 text-red-800 border-red-200';
            case 'en_reparation':
                return 'bg-blue-100 text-blue-800 border-blue-200';
            case 'termine':
                return 'bg-purple-100 text-purple-800 border-purple-200';
            default:
                return 'bg-gray-100 text-gray-800 border-gray-200';
        }
    };

    const getStatusIcon = (statut) => {
        switch(statut) {
            case 'valide':
                return (
                    <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                );
            case 'en_attente':
                return (
                    <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                );
            case 'refuse':
                return (
                    <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                    </svg>
                );
            case 'en_reparation':
                return (
                    <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                );
            case 'termine':
                return (
                    <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                );
            default:
                return null;
        }
    };

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) {
            return (
                <svg className="w-4 h-4 ml-1 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
                </svg>
            );
        }
        return sortConfig.direction === 'asc' ? (
            <svg className="w-4 h-4 ml-1 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
            </svg>
        ) : (
            <svg className="w-4 h-4 ml-1 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
        );
    };

    const filteredDemandes = demandes
        .filter(demande => {
            if (filter !== 'all') {
                const filterMap = {
                    'pending': 'en_attente',
                    'validated': 'valide',
                    'repairing': 'en_reparation',
                    'rejected': 'refuse',
                    'done': 'termine'
                };
                if (demande.statut !== filterMap[filter]) return false;
            }

            if (searchTerm) {
                const term = searchTerm.toLowerCase();
                return (
                    demande.vehicule?.numero?.toLowerCase().includes(term) ||
                    demande.vehicule?.marque?.toLowerCase().includes(term) ||
                    demande.vehicule?.modele?.toLowerCase().includes(term) ||
                    demande.demandeur?.nom?.toLowerCase().includes(term) ||
                    demande.type_reparation?.toLowerCase().includes(term)
                );
            }

            return true;
        })
        .sort((a, b) => {
            let aValue = a[sortConfig.key];
            let bValue = b[sortConfig.key];

            // Tri spécial pour les dates
            if (sortConfig.key.includes('date') || sortConfig.key.includes('created') || sortConfig.key.includes('updated')) {
                aValue = new Date(aValue);
                bValue = new Date(bValue);
            }

            // Tri spécial pour les noms
            if (sortConfig.key === 'vehicule') {
                aValue = a.vehicule?.marque || '';
                bValue = b.vehicule?.marque || '';
            }

            if (sortConfig.key === 'demandeur') {
                aValue = a.demandeur?.nom || '';
                bValue = b.demandeur?.nom || '';
            }

            if (aValue < bValue) {
                return sortConfig.direction === 'asc' ? -1 : 1;
            }
            if (aValue > bValue) {
                return sortConfig.direction === 'asc' ? 1 : -1;
            }
            return 0;
        });

    // Statistiques
    const stats = {
        all: demandes.length,
        pending: demandes.filter(d => d.statut === 'en_attente').length,
        validated: demandes.filter(d => d.statut === 'valide').length,
        repairing: demandes.filter(d => d.statut === 'en_reparation').length,
        rejected: demandes.filter(d => d.statut === 'refuse').length,
        done: demandes.filter(d => d.statut === 'termine').length
    };

    if (loading) {
        return (
            <div className="min-h-screen  py-8">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="text-center py-12">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-700 mx-auto"></div>
                        <p className="mt-4 text-gray-600">Chargement des demandes...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen  py-8">
            <div className="max-w-7xl mx-auto px-4">
                {/* Header */}
                <div className="mb-8">
                    <div className="flex justify-between items-center mb-6">
                        <div>
                            <h1 className="text-2xl font-bold text-gray-900">Demandes de réparation</h1>
                            <p className="text-gray-600 mt-1">
                                {stats.all} demande(s) au total
                            </p>
                        </div>
                        
                        <div className="flex space-x-2">
                            {user && ['client', 'mecanicien', 'validateur'].includes(user.role) && (
                                <Link
                                    to="/demandes-reparation/nouvelle"
                                    className="bg-gray-800 text-white px-4 py-2 rounded-lg text-sm hover:bg-gray-700 transition flex items-center"
                                >
                                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                    </svg>
                                    Nouvelle demande
                                </Link>
                            )}
                            <button
                                onClick={fetchDemandes}
                                className="text-gray-700 hover:text-gray-900 text-sm font-medium flex items-center"
                            >
                                <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                </svg>
                                Actualiser
                            </button>
                        </div>
                    </div>

                    {/* Barre de recherche */}
                    <div className="mb-6">
                        <div className="relative">
                            <input
                                type="text"
                                placeholder="Rechercher par véhicule, demandeur ou type..."
                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500 text-sm"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <svg className="absolute right-3 top-3 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                        </div>
                    </div>
                </div>

                {/* Filtres et statistiques */}
                <div className="mb-6">
                    <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                        <div>
                            <div className="text-sm text-gray-700 mb-2">Filtrer par statut :</div>
                            <div className="flex flex-wrap gap-2">
                                {[
                                    { key: 'all', label: 'Toutes', count: stats.all, color: 'bg-gray-200' },
                                    { key: 'pending', label: 'En attente', count: stats.pending, color: 'bg-yellow-200' },
                                    { key: 'validated', label: 'Validées', count: stats.validated, color: 'bg-green-200' },
                                    { key: 'repairing', label: 'En réparation', count: stats.repairing, color: 'bg-blue-200' },
                                    { key: 'rejected', label: 'Refusées', count: stats.rejected, color: 'bg-red-200' },
                                    { key: 'done', label: 'Terminées', count: stats.done, color: 'bg-purple-200' }
                                ].map((btn) => (
                                    <button
                                        key={btn.key}
                                        onClick={() => setFilter(btn.key)}
                                        className={`px-3 py-2 rounded-lg text-sm font-medium transition flex items-center ${
                                            filter === btn.key 
                                                ? 'bg-gray-800 text-white' 
                                                : 'bg-white text-gray-700 border border-gray-300 hover:'
                                        }`}
                                    >
                                        <div className={`w-2 h-2 rounded-full mr-2 ${btn.color}`}></div>
                                        {btn.label}
                                        <span className={`ml-2 px-1.5 py-0.5 text-xs rounded ${
                                            filter === btn.key 
                                                ? 'bg-gray-700 text-white' 
                                                : 'bg-gray-100 text-gray-600'
                                        }`}>
                                            {btn.count}
                                        </span>
                                    </button>
                                ))}
                            </div>
                        </div>
                        
                        <div className="text-sm text-gray-500">
                            {filteredDemandes.length} demande(s) trouvée(s)
                        </div>
                    </div>
                </div>

                {error && (
                    <div className="mb-6 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg">
                        <div className="flex items-center">
                            <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                            </svg>
                            <span>{error}</span>
                        </div>
                    </div>
                )}

                {/* Tableau des demandes */}
                {filteredDemandes.length === 0 ? (
                    <div className="bg-white border border-gray-300 rounded-lg p-8 text-center">
                        <svg className="w-12 h-12 text-gray-300 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        <h3 className="text-lg font-medium text-gray-600 mb-2">
                            {searchTerm 
                                ? `Aucune demande ne correspond à "${searchTerm}"`
                                : filter !== 'all'
                                ? `Aucune demande avec ce statut`
                                : 'Aucune demande de réparation'}
                        </h3>
                        {user && ['client', 'mecanicien', 'validateur'].includes(user.role) && !searchTerm && filter === 'all' && (
                            <Link
                                to="/demandes-reparation/nouvelle"
                                className="text-gray-600 hover:text-gray-800 text-sm font-medium"
                            >
                                Créer la première demande
                            </Link>
                        )}
                    </div>
                ) : (
                    <div className="bg-white border border-gray-300 rounded-lg overflow-hidden shadow-sm">
                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="">
                                    <tr>
                                        <th 
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                                            onClick={() => handleSort('id')}
                                        >
                                            <div className="flex items-center">
                                                ID
                                                {getSortIcon('id')}
                                            </div>
                                        </th>
                                        <th 
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                                            onClick={() => handleSort('vehicule')}
                                        >
                                            <div className="flex items-center">
                                                Véhicule
                                                {getSortIcon('vehicule')}
                                            </div>
                                        </th>
                                        <th 
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                                            onClick={() => handleSort('demandeur')}
                                        >
                                            <div className="flex items-center">
                                                Demandeur
                                                {getSortIcon('demandeur')}
                                            </div>
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Type de réparation
                                        </th>
                                        <th 
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                                            onClick={() => handleSort('km_actuel')}
                                        >
                                            <div className="flex items-center">
                                                Km
                                                {getSortIcon('km_actuel')}
                                            </div>
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Statut
                                        </th>
                                        <th 
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                                            onClick={() => handleSort('created_at')}
                                        >
                                            <div className="flex items-center">
                                                Date création
                                                {getSortIcon('created_at')}
                                            </div>
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Actions
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {filteredDemandes.map((demande) => (
                                        <tr key={demande.id} className="hover: transition-colors">
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm font-medium text-gray-900">#{demande.id}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div>
                                                    <div className="text-sm font-medium text-gray-900">
                                                        {demande.vehicule?.marque} {demande.vehicule?.modele}
                                                    </div>
                                                    <div className="text-xs text-gray-500">
                                                        {demande.vehicule?.numero || 'N/A'}
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div>
                                                    <div className="text-sm font-medium text-gray-900">
                                                        {demande.demandeur?.nom || 'N/A'}
                                                    </div>
                                                    <div className="text-xs text-gray-500">
                                                        {demande.demandeur?.role || 'Client'}
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-gray-900 max-w-xs truncate">
                                                    {demande.type_reparation || 'Non spécifié'}
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-gray-900">
                                                    {demande.km_actuel?.toLocaleString()} km
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border ${getStatusBadge(demande.statut)}`}>
                                                    {getStatusIcon(demande.statut)}
                                                    {translateStatus(demande.statut)}
                                                </span>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-gray-900">
                                                    {new Date(demande.created_at).toLocaleDateString('fr-FR')}
                                                </div>
                                                <div className="text-xs text-gray-500">
                                                    {new Date(demande.created_at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                                <div className="flex items-center space-x-3">
                                                    <Link
                                                        to={`/demandes-reparation/${demande.id}`}
                                                        className="text-blue-600 hover:text-blue-900 flex items-center"
                                                        title="Voir les détails"
                                                    >
                                                        <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                        </svg>
                                                        Détails
                                                    </Link>
                                                    
                                                    {/* Bouton Valider pour validateurs/chefs d'équipe */}
                                                    {user && ['validateur', 'chef_equipe'].includes(user.role) && demande.statut === 'en_attente' && (
                                                        <Link
                                                            to={`/validations/nouvelle?demande_id=${demande.id}`}
                                                            className="text-green-600 hover:text-green-900 flex items-center"
                                                            title="Valider cette demande"
                                                        >
                                                            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                                            </svg>
                                                            Valider
                                                        </Link>
                                                    )}
                                                    
                                                    {/* Bouton Créer réparation pour mécaniciens/validateurs */}
                                                    {user && ['mecanicien'].includes(user.role) && demande.statut === 'valide' && (
                                                        <Link
                                                            to={`/reparations/nouvelle?demande_id=${demande.id}`}
                                                            className="text-purple-600 hover:text-purple-900 flex items-center"
                                                            title="Créer une réparation"
                                                        >
                                                            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                                            </svg>
                                                            Réparer
                                                        </Link>
                                                    )}
                                                    
                                                    {/* Bouton Supprimer pour validateurs/chefs d'équipe */}
                                                    {user && ['validateur', 'chef_equipe'].includes(user.role) && (
                                                        <button
                                                            onClick={() => handleDelete(demande.id)}
                                                            className="text-red-600 hover:text-red-900 flex items-center"
                                                            title="Supprimer cette demande"
                                                        >
                                                            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                            </svg>
                                                            Supprimer
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}

                {/* Pagination ou info */}
                {filteredDemandes.length > 0 && (
                    <div className="mt-6 flex justify-between items-center text-sm text-gray-500">
                        <div>
                            Affichage de 1 à {filteredDemandes.length} sur {filteredDemandes.length} demande(s)
                        </div>
                        <div className="text-right">
                            Trié par {sortConfig.key === 'created_at' ? 'date' : sortConfig.key} 
                            ({sortConfig.direction === 'asc' ? 'croissant' : 'décroissant'})
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DemandeListVehicule;